export default __webpack_public_path__ + "static/media/arrow-down-right.1913f79b.svg";